import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";
import { NotificationsService } from "../services/notification.service";

class Component {
  message: string = '';
  type: string = '';

  constructor(
    private $rootScope: any,
    private NotificationsService: NotificationsService
  ) { }

  $onInit() {
    this.registerListeners();
  }

  private registerListeners() {
    // Subscribe to the "showMessage" event
    this.$rootScope.$on('showMessage', () => {
      this.message = this.NotificationsService.message;
      this.type = this.NotificationsService.type;
      this.$rootScope.isSearching = false;
    });

    // Subscribe to the "closeMessage" event
    this.$rootScope.$on('closeMessage', () => {
      this.closeMessage();
    });
  }

  closeMessage() {
    this.message = '';
    this.type = '';
  }
}

const component: ng.IComponentOptions = {
  bindings: {
    button: '=',
  },
  template: `
    <div id="goCerca" ng-show="message.length > 0">
      <div
        uib-alert
        class="alert-danger alert-dismissable"
        close="$ctrl.closeMessage()">
        {{$ctrl.message}}
      </div>
    </div>
  `,
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.MESSAGE, component);
